import { render } from "./EmailIcon.vue?vue&type=template&id=1382f133&ts=true"
import script from "./EmailIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailIcon.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/EmailIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1382f133"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1382f133', __exports__)) {
    api.reload('1382f133', __exports__)
  }
  
  module.hot.accept("./EmailIcon.vue?vue&type=template&id=1382f133&ts=true", () => {
    api.rerender('1382f133', render)
  })

}


export default __exports__